export enum PlayerType {
  BATTER = "batter",
  CATCHER = "catcher",
  PITCHER = "pitcher",
  FIELDER = "fielder",
  UMPIRE = "umpire",
  PLATE_UMPIRE = "plate-umpire",
  COACH = "coach",
}

export function getPlayerType(id: number): PlayerType {
  switch (id) {
    case 1:
      return PlayerType.PITCHER;
    case 10:
    case 11:
    case 12:
    case 13:
      return PlayerType.BATTER;
    case 2:
      return PlayerType.CATCHER;
    case 18:
    case 19:
      return PlayerType.COACH;
    case 14:
      return PlayerType.PLATE_UMPIRE;
    case 15:
    case 16:
    case 17:
    case 20:
    case 21:
      return PlayerType.UMPIRE;
    default:
      return PlayerType.FIELDER;
  }
}
